export default "__VITE_ASSET__D5cRPj$R__"